import { ClickAwayListener, IconButton} from "@material-ui/core";
import React from "react"
import { AddFactoryCommentForm } from "../components/panel/factoryCaseForm/AddFactoryCommentForm";
import { useDispatch, useSelector } from "react-redux";
import { setTableActiveCommentForm } from "../redux/factoryCases/factoryCasesSlice";
import { selectActiveCommentFormId } from "../redux/factoryCases/selectors";
import addCommentIcon from "../images/message.svg"

function FactoryMenuTable(props){

    const {data, id} = props;
    const dispatch = useDispatch();
    const selectedCommentForm = useSelector(selectActiveCommentFormId)
    const isVisible = selectedCommentForm === id
    const disabled = data.data.state.toLowerCase() === "cerrado"

    function handleShowForms(){
        if(selectedCommentForm === id)
         {
            dispatch(setTableActiveCommentForm(null))          
        }
        else{
            dispatch(setTableActiveCommentForm(id))
        }
    }

    function handleClick(e){
        handleShowForms();
    }

    function handleClickAway(){
        handleShowForms()
    }

    return(
        <div id={`button-${id}`}>
            <IconButton onClick={(e)=>{handleClick(e)}} disabled={disabled} size="small"><img width={20} src={addCommentIcon}/></IconButton>
            {isVisible && <ClickAwayListener onClickAway={handleClickAway}>
                <div>
                    <AddFactoryCommentForm 
                    formClassName={"comment-form-table"}
                    anchorId={`button-${id}`}
                    showArrow
                    placement={"right"}
                    processId={data.data.processId} 
                    expedient={data.data.currentExpedient || data.data.expedient} 
                    showAddFactoryCommentForm={isVisible} 
                    handleShowForms={handleShowForms}
                    showConfirm={true}
                    setShowAddFactoryCommentForm={()=>dispatch(setTableActiveCommentForm(null))}
                    />
                </div>
            </ClickAwayListener>
            }   
          </div>

    )
}

export {FactoryMenuTable}

